import Swiper, { Pagination, Autoplay, Keyboard, EffectFade } from 'swiper';
Swiper.use([Pagination, Autoplay, Keyboard, EffectFade]);

function setButtonPosition() {
	if ($(window).width() > 767 && $(".swiper-auto-height-container").length > 0) {
		var leftPosition = parseInt($('.swiper-auto-height-container .swiper-slide').css('padding-left'));
		var bottomPosition = parseInt($('.swiper-auto-height-container .swiper-slide').css('padding-bottom'));
		var bannerWidth = parseInt($('.swiper-auto-height-container .slide-banner').outerWidth());
		$('.navigation-area').css({'left': bannerWidth + leftPosition + 'px', 'bottom': bottomPosition + 'px'});
	} else if ($(".swiper-auto-height-container").length > 0) {
		$('.navigation-area').css({'left': '', 'bottom': ''});
	}
}

var swiperFull;
var swiperClients;
var swiperPosts;
var swiperLoghi;
$(document).ready(function () {
	"use strict";

  if($('.swiper-loghi').length) {
    var swiperLoghi = new Swiper('.swiper-loghi', {
      slidesPerView: 2,
      spaceBetween: 22,
      allowTouchMove: true,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: true,
        waitForTransition: false
      },
      breakpoints: {
        640: {
          loop: false,
          slidesPerView: 2,
          spaceBetween: 16,
        },
        768: {
          loop: false,
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1024: {
          allowTouchMove: false,
          loop: false,
          slidesPerView: 5,
          spaceBetween: 32,
        },
        1200: {
          allowTouchMove: false,
          loop: false,
          slidesPerView: 5,
          spaceBetween: 20,
        },
      },
      on: {
        resize: function () {
          swiperLoghi.update();
        }
      }
    });
  }

	if($('.swiper-full-screen').length > 0 )
	{
		swiperFull = new Swiper('.swiper-full-screen', {
			loop: true,
			slidesPerView: 1,
			preventClicks: false,
			allowTouchMove: true,
			pagination: {
				el: '.swiper-full-screen-pagination',
				clickable: true
			},
			autoplay: {
				delay: 5000,
				disableOnInteraction: true,
				waitForTransition: false
			},
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
			speed: 2500,
			effect: "fade",
			fadeEffect: {
				crossFade: true
			},
			keyboard: {
				enabled: true
			},
			on: {
				resize: function () {
					swiperFull.update();
				}
			}
		});
	}
	if($('.swiper-number-pagination').length > 0 ) {
		swiperClients = new Swiper('.swiper-number-pagination', {
      allowTouchMove: true,
      preventClicks: false,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true
      },
      pagination: {
        el: '.swiper-number',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + pad((index + 1)) + '</span>';
        }
      },
      on: {
        resize: function () {
          swiperClients.update();
        }
      }
		});
	}
  if($('.swiper-posts').length > 0 ) {
    swiperPosts = new Swiper('.swiper-posts', {
      slidesPerView: 1,
      spaceBetween: 32,
      allowTouchMove: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 18,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
      on: {
        resize: function () {
          swiperPosts.update();
        }
      }
    });
  }
	window.setTimeout(function(){
		if( swiperFull ) swiperFull.update();
    if( swiperClients ) swiperClients.update();
    if( swiperPosts ) swiperPosts.update();
    if( swiperLoghi ) swiperLoghi.update();
	}, 500);
});
$(window).resize(function () {
	setTimeout(function () {
		if ($('.swiper-full-screen').length > 0 && swiperFull) {
			swiperFull.update();
		}
    if ($('.swiper-number-pagination').length > 0 && swiperClients) {
      swiperClients.update();
    }
    if ($('.swiper-posts').length > 0 && swiperPosts) {
      swiperPosts.update();
    }
    if ($('.swiper-loghi').length > 0 && swiperLoghi) {
      swiperLoghi.update();
    }
	}, 500);
	if (isIE()) {
		setTimeout(function () {
			if ($('.swiper-full-screen').length > 0 && swiperFull) {
				swiperFull.update();
			}
		}, 500);
    setTimeout(function () {
      if ($('.swiper-number-pagination').length > 0 && swiperClients) {
        swiperClients.update();
      }
    }, 500);
    setTimeout(function () {
      if ($('.swiper-posts').length > 0 && swiperPosts) {
        swiperPosts.update();
      }
    }, 500);
    setTimeout(function () {
      if ($('.swiper-loghi').length > 0 && swiperLoghi) {
        swiperLoghi.update();
      }
    }, 500);
	}
});
function pad(d) {
  return (d < 10) ? '0' + d.toString() : d.toString();
}
function isIE() {
	var ua = window.navigator.userAgent;
	var msie = ua.indexOf("MSIE ");
	if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {  // If Internet Explorer, return version number
		return true;
	} else // If another browser, return 0
	{
		return false;
	}
}



// WEBPACK FOOTER //
// ./scripts/elements/_swiper.js